module.exports = __webpack_public_path__ + "static/media/normas.11de152e.jpg";